module.exports = __webpack_public_path__ + "static/dmon-007-3b738584cfb3018b20525a2fd6f7d7ab.jpg";